import { useEffect, useRef } from 'react';
import { useLoaderData } from '@tanstack/react-router';

type Message = { id: number; text: string; priority: number };

const SPEED = 50;
const ITEM_CLASS = 'goldman font-bold text-3xl max-sm:text-2xl mx-4 text-white';

export default function Marquee() {
	const data = useLoaderData({ from: '__root__' });
	const messages: Array<Message> = [...(data?.scrollingMessagesOrNull ?? [])].sort(
		(a, b) => a.priority - b.priority,
	);

	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		let raf: number;
		let last: number;
		let offset = 0;

		const tick = (now: number) => {
			offset -= SPEED * ((now - (last ?? now)) / 1000);
			last = now;

			if (Math.abs(offset) >= el.scrollWidth / 2) offset = 0;

			el.style.transform = `translateX(${offset}px)`;
			raf = requestAnimationFrame(tick);
		};

		raf = requestAnimationFrame(tick);
		return () => cancelAnimationFrame(raf);
	}, []);

	return (
		<div className="bg-black py-4 max-sm:py-2 overflow-hidden">
			<div ref={ref} className="flex whitespace-nowrap w-max">
				{['a', 'b'].map((prefix) =>
					messages.map((item) => (
						<div key={`${prefix}-${item.id}`} className={ITEM_CLASS}>
							{item.text}
						</div>
					)),
				)}
			</div>
		</div>
	);
}
